// Import Views
import Home from 'barba/views/home';

// Initialize Views
Home.init();



// WEBPACK FOOTER //
// ./resources/assets/js/barba/views/index.js